var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('section',{staticClass:"header"},[_vm._v("\n\t\t"+_vm._s(_vm.title)+"\n\t")]),_c('div',{staticClass:"mathjax-container"},[_c('iframe',{staticClass:"iframe-box",attrs:{"srcdoc":_vm.iframeContent,"height":"","frameborder":"0"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }